
import Header from "../components/header";

export default function content() {
  return (
    <div className='flex flex-col lg:flex-row w-full am-movein'>
      <div className="w-full mx-0 lg:mr-4 flex flex-col px-8 py-8 text-2xl text-white leading-normal border bc-foreground">
        <Header
          text={ "Front End"}>
        </Header>

        <div className='mt-6'>
          As a front end developer, I have designed & developed software for clients across Technology,
          Medical Services and Shipping in a professional capacity.
        </div>
        <div className='mt-8'>
          Across the majority of these projects, I have been the lead designer within a team and have worked
          with clients to create website(s) that accurately and successfully advertises their business.
        </div>
        <div className='mt-8'>
          Additionally, I have developed alterations & additions (within both helpdesks & long-term developments) to pre-existing software
          across Lodging, Hospitality, Shipping, Real Estate, Childcare and Administration in accordance with pre-existing designs and styling.
        </div>
      </div>

      <div className="w-full mt-4 lg:mt-0 mx-0 lg:ml-4 flex flex-col px-8 py-8 text-2xl text-white leading-normal border bc-foreground">
        <Header
          text={ "Back End"}>
        </Header>

        <div className='mt-6'>
          As a back end developer, I have built complex server-side processes & enterprise scale databases.
        </div>
        <div className='mt-8'>
          Across these projects, I have worked as a developer within teams to collaboratively produce high-quality, complex solutions for numerous clients.
          I have also led enterprise level projects where I have designed complex processes to handle large amounts of data from multiple APIs.
        </div>
        <div className='mt-8'>
          Additionally, I have developed alterations & additions (within both helpdesks & long-term developments) to pre-existing software
          across Lodging, Hospitality, Shipping, Real Estate, Childcare and Administration in accordance with pre-exisiting technology stacks
          and architecture.
        </div>
      </div>
    </div>
  )
}